import { useSearchParams } from 'react-router'

import { getAppUrl } from '@/lib/helpers/envHelpers'
import { SHARED_SEARCH_PARAMS } from '@/lib/searchParams'

function isSafeUrl(url: string | null): boolean {
  if (!url) {
    return false
  }

  // Relative URLs are safe (they navigate within the same origin)
  if (url.startsWith('/') || url.startsWith('./') || url.startsWith('../')) {
    return true
  }

  // For absolute URLs, validate the origin matches the app URL
  try {
    const urlObj = new URL(url)
    const appUrlObj = new URL(getAppUrl())

    // Validate that the domain matches the app URL domain
    return urlObj.origin === appUrlObj.origin
  } catch {
    // If URL parsing fails and it's not a relative URL, it's not valid
    return false
  }
}

export function useBackLinkParams() {
  const [searchParams] = useSearchParams()
  const backUrl = searchParams.get(SHARED_SEARCH_PARAMS.backUrl)

  return {
    backLabel: searchParams.get(SHARED_SEARCH_PARAMS.backLabel) || 'Back',
    backUrl: isSafeUrl(backUrl) ? backUrl : null,
  }
}
